<template>
  <v-card elevation="2" flat>
    <template v-if="!loading && document">
      <v-card-subtitle>
        <dl class="dl-horizontal">
          <dt><strong>Betreff:</strong></dt>
          <dd>
            <div>{{ subject }}</div>
          </dd>
          <dt><strong>Datum:</strong></dt>
          <dd>
            <div>{{ formatDate(document.documentDate) }}</div>
          </dd>
          <dt><strong>Empfänger:</strong></dt>
          <dd>
            <div>{{ document.to }}</div>
          </dd>
        </dl>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text
        class="mt-4"
        style="flex-grow: 1; border: none; margin: 0; padding: 0"
      >
        <iframe
          ref="emailFrame"
          class="email-iframe"
          ant="outlined"
          :src="iframeSource"
        />
      </v-card-text>
    </template>
    <template v-else>
      <v-card-text>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import NotificationObject from '@/main/NotificationObject.js';
import TimeUtility from '@/util/TimeUtility.js';
import { HTTP } from '@/main/httpClient.js';
import { XMLParser } from 'fast-xml-parser';
import rfc2047 from 'rfc2047';

const EMAIL_TYPE = {
  SPOT: 'SPOT',
  VARIO: 'VARIO'
};

export default {
  name: 'EmailPreview',
  props: {
    customerId: { type: Number, required: true },
    documentId: { type: Number, required: true }
  },
  data: () => ({
    loading: false,
    document: null
  }),
  computed: {
    documentContent() {
      let content = this.document?.content;
      if (!content) return '';
      content = Buffer.from(content, 'base64').toString('utf-8');
      return content;
    },
    subject() {
      return rfc2047.decode(this.document?.subject);
    },
    contentType() {
      const varioString = String.fromCharCode(65279) + '<?xml';
      if (this.documentContent?.startsWith(varioString)) {
        return EMAIL_TYPE.VARIO;
      }

      return EMAIL_TYPE.SPOT;
    },
    iframeSource() {
      if (this.contentType === EMAIL_TYPE.VARIO) {
        const parser = new XMLParser();
        const content = parser.parse(this.documentContent);

        return this.createIframeDataUrl(
          Buffer.from(content.EMAIL.BODY, 'utf8').toString('base64')
        );
      }

      return this.createIframeDataUrl(this.document?.content);
    }
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$emit('loading-started');
      this.loading = true;
      HTTP.get(`/email-archive/customer/${this.customerId}/${this.documentId}`)
        .then(({ data }) => {
          this.document = data;
        })
        .catch((err) => {
          console.error(err);
          this.showMessage('error', 'Die E-Mail konnte nicht geladen werden');
        })
        .finally(() => {
          this.loading = false;
          this.$emit('loading-complete');
        });
    },
    createIframeDataUrl(base64Content) {
      return `data:text/html;base64,${base64Content}`;
    },
    formatDate(date) {
      if (!date) return date;
      return TimeUtility.formatLocalDate(date);
    },
    showMessage: function (type, description) {
      this.$store.commit(
        'addNotification',
        new NotificationObject(type, description)
      );
    }
  }
};
</script>
<style scoped>
.email-iframe {
  width: 100%;
  border: none;
  height: calc(95vh - 200px);
  background-color: white;
}

dl {
  display: grid;
  grid-template-rows: auto auto;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
}
</style>
